/* eslint-disable jsx-a11y/alt-text */
import MediaBorders from 'constants/media-borders';
import React from 'react';

const Image = ({
  pc1x,
  pc2x,
  sp2x,
  sp3x,
  common1x,
  common2x,
  common3x,
  webpPC1x,
  webpPC2x,
  webpSP2x,
  webpSP3x,
  ...props
}) => {
  if (
    [pc1x, pc2x, sp2x, sp3x, webpPC1x, webpPC2x, webpSP2x, webpSP3x].filter(
      Boolean
    ).length === 8
  ) {
    return (
      <picture>
        <source
          media={`(min-width: ${MediaBorders.umedium})`}
          type="image/webp"
          srcSet={`${webpPC1x} 1x,${webpPC2x} 2x`}
        />
        <source
          media={`(min-width: ${MediaBorders.umedium})`}
          srcSet={`${pc1x} 1x,${pc2x} 2x`}
        />
        <source
          type="image/webp"
          srcSet={`${webpSP2x} 1x,${webpSP2x} 2x,${webpSP3x} 3x`}
        />
        <source
          srcSet={`${sp2x} 1x,${sp2x} 2x,${sp3x} 3x`}
        />
        <img src={pc1x} {...props} />
      </picture>
    );
  }

  if ([pc1x, pc2x, sp2x, sp3x].filter(Boolean).length === 4) {
    return (
      <picture>
        <source
          media={`(min-width: ${MediaBorders.umedium})`}
          srcSet={`${pc1x} 1x,${pc2x} 2x`}
        />
        <source
          srcSet={`${sp2x} 1x,${sp2x} 2x,${sp3x} 3x`}
        />
        <img src={pc1x} {...props} />
      </picture>
    );
  }

  if ([common1x, common2x, common3x].filter(Boolean).length === 3) {
    return (
      <picture>
        <source
          srcSet={`${common1x} 1x,${common2x} 2x,${common3x} 3x`}
        />
        <img src={common1x} {...props} />
      </picture>
    );
  }

  if ([pc1x, pc2x].filter(Boolean).length === 2) {
    return (
      <picture>
        <source
          srcSet={`${pc1x} 1x,${pc2x} 2x,`}
        />
        <img src={pc1x} {...props} />
      </picture>
    );
  }

  return null;
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/common/Image/index.js